import { Series, useCurrentFrame, useVideoConfig } from 'remotion';
import { useMemo } from 'react';
import { CompositeSegment } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Segment/CompositeSegment';
import PlayRangeComponent from './PlayRangeComponent';

export const PlayRangesComponent = ({
  segment,
  canEditSpeakerLabel,
  canManuallyReposition,
  preventOverlappingWithOtherCrops
}: {
  segment: CompositeSegment;
  canEditSpeakerLabel: boolean;
  canManuallyReposition?: boolean;
  preventOverlappingWithOtherCrops?: boolean;
}) => {
  const { fps } = useVideoConfig();
  const frame = useCurrentFrame();
  const { prefixSum, activeIndex } = useMemo(() => {
    const prefix: number[] = [];
    let active = 0;
    for (var i = 0; i < segment.playRanges.length; i++) {
      if (i === 0) {
        prefix[i] = 0;
      } else {
        const prevRange = segment.playRanges[i - 1];
        prefix[i] = prefix[i - 1] + (prevRange.toFrame - prevRange.fromFrame);
      }
      if (frame >= prefix[i]) {
        active = i;
      }
    }
    return { prefixSum: prefix, activeIndex: active };
  }, [segment.playRanges, frame]);
  return (
    <Series>
      {segment.playRanges.map((playRange, i) => (
        <Series.Sequence
          premountFor={30 * fps}
          durationInFrames={playRange.toFrame - playRange.fromFrame}
          key={`${playRange.fromFrame}-${playRange.toFrame}`}
          style={{ pointerEvents: i === activeIndex ? 'auto' : 'none' }}
        >
          <PlayRangeComponent
            offset={prefixSum[i]}
            segment={segment}
            canEditSpeakerLabel={canEditSpeakerLabel}
            canManuallyReposition={canManuallyReposition}
            preventOverlappingWithOtherCrops={preventOverlappingWithOtherCrops}
          />
        </Series.Sequence>
      ))}
    </Series>
  );
};
